import React, { Component } from 'react';
import { message } from 'antd';
import { asyncConnect } from 'react-async-client';
import { pluralize } from 'numeralize-ru';
import { pathOr, path, assoc } from 'ramda';

import { openPaymentModal } from '../../actions/modalActions';
import { postSurveyCompanyMessages, getSurveyRespondents } from '../../actions/asyncActions';
import { SURVEY_LETTER_TEMPLATE_VARIABLES } from '../../constants/questionnary';
import LetterForm from '../forms/LetterForm';
import Modal from './Modal';

class SurveyRespondentLetterModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: pathOr([], ['params', 'item', 'respondentsFilter', 'respondents'], props).length
        };
    }

    setCount = count => this.setState({ count });

    render() {
        const { modal, postSurveyCompanyMessages, params: { item, filtered, count }} = this.props;
        const amount = filtered ? count : this.state.count;

        return <Modal
            {...modal}
            title={`Отправить письмо ${amount} ${pluralize(amount, 'респонденту', 'респондентам', 'респондентам')}`}
            footer={null}>
            <LetterForm
                formAction={postSurveyCompanyMessages}
                respondentsAction={getSurveyRespondents}
                contentOptions={SURVEY_LETTER_TEMPLATE_VARIABLES}
                filtered={filtered}
                item={item}
                mapBeforeSubmit={values => {
                    return assoc('respondents', path(['respondentsFilter', 'respondents'], values), values);
                }}
                setCount={this.setCount}
                amount={amount}
            />
        </Modal>;
    }
}

export default asyncConnect({
    postSurveyCompanyMessages: postSurveyCompanyMessages
        .withSuccessHandler(({ close, params: { clearSelected } }) => {
            message.success('Письмо было успешно отправлено');
            clearSelected();
            close();
        })
        .withErrorHandler(({ postSurveyCompanyMessages: { meta }, openPaymentModal, params }) => {
            const neededBalance = path(['error', 'data', 'errors', 0, 'attributes', 'neededBalance'], meta);

            if (neededBalance) {
                message.error('Недостаточно юнитов на балансе компании');
                openPaymentModal({ company: path(['item', 'company'], params) });
            } else {
                message.error('Не удалось отправить письмо');
            }
        })
        .withOptions({ resetOnUnmount: true })
}, null, { openPaymentModal })(SurveyRespondentLetterModal);
